/**
 * ppc-animations.js
 * The Proper Pillow Co — scroll-triggered fade-in animations
 */

(function () {
  const ANIMATION_CLASS = 'ppc-animate';
  const VISIBLE_CLASS   = 'ppc-animate--visible';

  const CSS = `
    .ppc-animate {
      opacity: 0 !important;
      transform: translateY(36px) !important;
      transition: opacity 0.8s ease, transform 0.8s ease !important;
      will-change: opacity, transform;
    }
    .ppc-animate--visible {
      opacity: 1 !important;
      transform: translateY(0) !important;
    }
    .ppc-animate--delay-1 { transition-delay: 0.12s !important; }
    .ppc-animate--delay-2 { transition-delay: 0.24s !important; }
    .ppc-animate--delay-3 { transition-delay: 0.36s !important; }

    /* Eyebrows — fade only, no slide */
    .ppc-animate-eyebrow {
      opacity: 0 !important;
      transition: opacity 0.6s ease !important;
    }
    .ppc-animate-eyebrow--visible {
      opacity: 1 !important;
    }
  `;

  const style = document.createElement('style');
  style.textContent = CSS;
  document.head.appendChild(style);

  const SELECTORS = [
    // Homepage
    '.ppc-st__card',
    '.ppc-guarantee__block',
    '.ppc-problem__body',
    '.ppc-solution__body',
    '.ppc-construction__feature',
    '.ppc-hero__text-inner',
    '.ppc-hero__image-col',
    // Product page sections
    '.pillow-for__inner',
    '.pillow-why__inner',
    '.pillow-adjust__inner',
    '.pillow-materials__inner',
    '.ppc-faqs__item',
    // Guarantee page
    '.gp-split__inner',
    '.gp-step-card',
    '.gp-callout__inner',
    '.gp-cta__inner',
    // Shipping page
    '.sp-card',
    // Returns page
    '.rp-card',
    '.rp-tile',
    // Dawn product cards
    '.card-wrapper',
  ].join(', ');

  const EYEBROW_SELECTORS = [
    // Homepage
    '.ppc-st__eyebrow',
    '.ppc-guarantee__eyebrow',
    '.ppc-problem__eyebrow',
    '.ppc-solution__eyebrow',
    '.ppc-construction__eyebrow',
    // Product page
    '.pillow-for__eyebrow',
    '.pillow-why__eyebrow',
    '.pillow-adjust__eyebrow',
    '.pillow-materials__eyebrow',
    '.ppc-faqs__eyebrow',
    // Guarantee page
    '.gp-split__eyebrow',
    '.gp-steps__eyebrow',
    '.gp-callout__tag',
    // Shipping page
    '.sp-hero__eyebrow',
  ].join(', ');

  const GRID_PARENTS = [
    '.ppc-st__grid',
    '.ppc-guarantee__grid',
    '.ppc-construction__features',
    '.gp-steps__grid',
    '.sp-cards__grid',
    '.rp-cards__grid',
    '.rp-tiles',
    '.ppc-faqs__list',
  ].join(', ');

  function init() {
    const elements = document.querySelectorAll(SELECTORS);
    elements.forEach(function (el) {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.75) return;
      el.classList.add(ANIMATION_CLASS);
    });

    // Eyebrows — fade only
    document.querySelectorAll(EYEBROW_SELECTORS).forEach(function (el) {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.75) return;
      el.classList.add('ppc-animate-eyebrow');
    });

    // Stagger grid children
    document.querySelectorAll(GRID_PARENTS).forEach(function (grid) {
      const children = Array.from(grid.children).filter(c => c.classList.contains(ANIMATION_CLASS));
      children.forEach(function (child, i) {
        if (i > 0 && i <= 3) child.classList.add('ppc-animate--delay-' + i);
      });
    });

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add(VISIBLE_CLASS);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.' + ANIMATION_CLASS).forEach(function (el) {
      observer.observe(el);
    });

    // Eyebrow observer
    const eyebrowObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ppc-animate-eyebrow--visible');
          eyebrowObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -20px 0px' });

    document.querySelectorAll('.ppc-animate-eyebrow').forEach(function (el) {
      eyebrowObserver.observe(el);
    });
  }

  function run() { setTimeout(init, 150); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
